import React from "react";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import {
  DESCENDENT_COMMISSIONS,
  TOP_GAINERS_URL,
  TOP_LOSERS_URL,
} from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const BrokerDashboard = () => {
  const [gainers, setGainers] = useState({});
  const [losers, setLosers] = useState([]);
  const [activeCount, setactiveCount] = useState(0);
  const [totCommission, settotCommission] = useState(0);

  const [commissions, setCommissions] = useState([]);
  const [SidebarState, setSidebarState] = useState(false);
  const [loyaltyPoints, setloyaltyPoints] = useState(0);
 const referrals = encStorage.getItem("refer");
 //console.log('count',referrals);
  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
  };
  const fetchGainers = async () => {
    setactiveCount(0);
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(TOP_GAINERS_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const gainersData =
        response.data.gainers == null ? [] : response.data.gainers;
      setGainers(gainersData);
      setactiveCount((prevCount) => prevCount + gainersData.length);
    } catch (error) {
      setGainers([]);
      console.error("Error fetching gainers:", error);
    }
  };

  const fetchLosers = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(TOP_LOSERS_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const losersData =
        response.data.losers == null ? [] : response.data.losers;
      setLosers(losersData);
      setactiveCount((prevCount) => prevCount + losersData.length);
    } catch (error) {
      setLosers([]);
      console.error("Error fetching losers:", error);
    }
  };

  const fetchCommissions = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(DESCENDENT_COMMISSIONS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const commissionsData =
        response.data.commissions == null ? [] : response.data.commissions;
      setCommissions(commissionsData);
      const totalCommission = commissionsData.reduce(
        (total, commission) => total + parseFloat(commission.totalCommission),
        0
      ).toFixed(2);
      settotCommission(totalCommission);
    } catch (error) {
      setCommissions([]);
      console.error("Error fetching commissions:", error);
    }
  };

  useEffect(() => {
    fetchGainers();
    fetchLosers();
    fetchCommissions();
    setactiveCount(0);
    const interval = setInterval(() => {
      setactiveCount(0);
      fetchGainers();
      fetchLosers();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <div className="container-fluid px-4">
            <div className="d-flex justify-content-between">
              <h3 className="mt-4">
                Broker's Window ({new Date().toLocaleDateString()})
              </h3>
            </div>
            <div className="w-100 mt-2">
              <div className="border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Active</h6>
                          <h6 className="ps-1 fs-4">{activeCount ?? 0}/{referrals}</h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Gainers</h6>
                          <h6 className="ps-1 fs-4">{gainers.length ?? 0}</h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Losers</h6>
                          <h6 className="ps-1 fs-4">{losers.length ?? 0}</h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Commission</h6>
                          <h6 className="ps-1 fs-4">{totCommission ?? 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-1">
                      <div className="card bg-brand-white text-light broker-window-card-height ">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Top Gainers</h6>
                          {gainers.length > 0 ? (
                            <table border="0" class="w-100">
                              {gainers.map((gainer, index) => (
                                <tr key={index}>
                                  <td>{gainer.accountId}</td>
                                  <td>{gainer.client.name}</td>
                                  <td
                                    style={{
                                      color:
                                        gainer.totalCloseProfit > 0
                                          ? "green"
                                          : "red",
                                    }}
                                  >
                                    {gainer.totalCloseProfit}
                                  </td>
                                </tr>
                              ))}
                            </table>
                          ) : (
                            <p>No gainers available</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mt-1">
                      <div className="card bg-brand-white text-light broker-window-card-height ">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Top Losers</h6>
                          {losers.length > 0 ? (
                            <table border="0" class="w-100">
                              {losers.map((loser, index) => (
                                <tr key={index}>
                                  <td>{loser.accountId}</td>
                                  <td>{loser.client.name}</td>
                                  <td
                                    style={{
                                      color:
                                        loser.totalCloseProfit > 0
                                          ? "green"
                                          : "red",
                                    }}
                                  >
                                    {loser.totalCloseProfit}
                                  </td>
                                </tr>
                              ))}
                            </table>
                          ) : (
                            <p>No losers available</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mt-1">
                      <div className="card bg-brand-white text-light broker-window-card-height ">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Commissions</h6>
                          {commissions.length > 0 ? (
                            <table border="0" class="w-100">
                              {commissions
                                .filter(
                                  (commission) =>
                                    parseFloat(commission.totalCommission) !== 0
                                )
                                .map((commission, index) => (
                                  <tr key={index}>
                                    <td>{commission.accountId}</td>
                                    <td>{commission.name}</td>
                                    <td>{commission.totalCommission}</td>
                                  </tr>
                                ))}
                            </table>
                          ) : (
                            <p>No Commissions available</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrokerDashboard;
